import { getCookie } from 'cookies-next';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getFilteredProperties2 = async (filters, email = null, localeValue = 'en') => {
    let currencyValue = getCookie('currency')

    const {
        // ── existing ──────────────────────────────────────────────────────────
        saleType,
        name,
        bts,
        project,
        category,
        categories,
        room,
        bathroom,
        page,
        minprice,
        maxprice,
        minlivingarea,
        maxlivingarea,
        petfriendly,
        seaview,
        beachfront,
        agent      = undefined,
        map,
        sort,
        district,
        districts,
        location,
        // ── new ───────────────────────────────────────────────────────────────
        rooms,          // multi-bedroom filter (comma-separated, e.g. "studio,1,2")
        area,           // district name string (backend finds matching district IDs)
        foreignquota,   // foreign quota filter
        mountainview,   // mountain view filter
        riverview,   // river view filter
        parkview,   // park view filter
        amenities,
        province,       // single province filter (province id/key)
        provinces,      // multi province filter (comma-separated province ids/keys)
    } = filters

    const params = new URLSearchParams()

    // Only append params that have a real value — avoids sending "undefined" strings
    const append = (key, val) => {
        if (val !== undefined && val !== null && val !== '' && val !== 'undefined' && val !== 'null') {
            params.append(key, val)
        }
    }

    append('saleType',     saleType)
    append('name',         name)
    append('bts',          bts)
    append('location',     location)
    append('area',         area)
    append('district',     district)
    append('districts',    districts)
    append('province',     province)
    append('provinces',    provinces)
    append('project',      project)
    append('category',     category)
    append('categories',   categories)
    append('minprice',     minprice)
    append('maxprice',     maxprice)
    append('minlivingarea',     minlivingarea)
    append('maxlivingarea',     maxlivingarea)
    append('room',         room)
    append('rooms',        rooms)
    append('bathroom',     bathroom)
    append('petfriendly',  petfriendly)
    append('seaview',      seaview)
    append('beachfront',   beachfront)
    append('foreignquota', foreignquota)
    append('mountainview', mountainview)
    append('riverview', riverview)
    append('parkview', parkview)
    append('amenities', amenities)
    append('agent',        agent)
    append('map',          map)
    append('page',         page)
    append('sort',         sort)
    append('limit',        filters.limit || 8)

    const url = `${baseUrl}/properties?${params.toString()}`

    const headers = {
        'apikey':  process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'email':   email,
        'currency': currencyValue || 'thb',
        'locale':  localeValue || 'en',
    }

    const response = await fetch(url, {
        headers,
        cache: 'no-store',
    })

    const result = await response.json()

    // Apply local like state for logged-out users who have cookie-stored likes
    const id    = getCookie('id')
    const likes = getCookie('likes')

    if (
        id == undefined &&
        likes !== undefined &&
        likes.length > 0 &&
        result.properties?.length > 0
    ) {
        result.properties.forEach(property => {
            if (likes.includes(property.id)) {
                property.isLiked = true
            }
        })
    }

    return result
}